export const GET_VISITOR_LIST = "GET_VISITOR_LIST"
export const GET_VISITOR_LIST_SUCCESS = "GET_VISITOR_LIST_SUCCESS"
export const GET_VISITOR_LIST_FAILED = "GET_VISITOR_LIST_FAILED"

export const GET_EMAIL_SETUP = "GET_EMAIL_SETUP"
export const GET_EMAIL_SETUP_SUCCESS = "GET_EMAIL_SETUP_SUCCESS"
export const GET_EMAIL_SETUP_FAILED = "GET_EMAIL_SETUP_FAILED"

export const UPDATE_EMAIL_SETUP = "UPDATE_EMAIL_SETUP"
export const UPDATE_EMAIL_SETUP_SUCCESS = "UPDATE_EMAIL_SETUP_SUCCESS"
export const UPDATE_EMAIL_SETUP_FAILED = "UPDATE_EMAIL_SETUP_FAILED"
